import { observer } from 'mobx-react';
import * as React from 'react';

import { ClickTracker } from 'bernie-analytics';
import { LocalizedText } from 'bernie-l10n';

import { FilterModel, FilterOptionModel } from 'components/common/search-form/fields/filter-types';

import { UitkSelect } from 'uitk-react-select';

import { FormFieldBinding } from 'components/common/search-form/fields/form-field-binding';
import { SearchFormFieldProps } from 'components/common/search-form/index';

const TrackedSelect = ClickTracker(UitkSelect);

@FormFieldBinding
@observer
export class SelectField extends React.Component<SearchFormFieldProps> {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
  }

  private handleChange(e) {
    const value = e.target.value;
    const { model, modelKey, sortAndFilterOptions, updateModel } = this.props;

    const select: FilterModel = sortAndFilterOptions && sortAndFilterOptions[modelKey];
    const selectName: string = select && select.name;
    const modelValue = model && model[selectName];

    if (typeof updateModel !== 'function' || typeof modelValue === 'undefined') {
      return;
    }

    updateModel({
      target: {
        name: selectName,
        value
      }
    });
  }

  public render() {
    const { model, modelKey, sortAndFilterOptions } = this.props;
    const select = sortAndFilterOptions && sortAndFilterOptions[modelKey];
    const selectName: string = select && select.name;
    const selectOptions: FilterOptionModel[] = select && select.options;

    const value = (model && model[selectName]) || '';

    if (!selectOptions || selectOptions.length === 0) {
      return null;
    }

    return (
      <fieldset>
        <TrackedSelect
          defaultValue={value}
          label={<LocalizedText message="hotels.searchResults.filtersDialog.sort.label" />}
          linkName={`${selectName}.select.${value}`}
          name={selectName}
          onChange={this.handleChange}
          rfrr={`${selectName}.${value}`}
          value={value}
        >
          {selectOptions.map((option, index) => (
            <option key={`${selectName}-${index}-${option.value}`} value={option.value}>
              {option.label}
            </option>
          ))}
        </TrackedSelect>
      </fieldset>
    );
  }
}
